import geoTagApi from '../../api/geotags'

const state = {
  geotags: [],
}

const mutations = {
  setTags (state, tags) {
    state.geotags = tags
  },
  addTag (state, tag) {
    state.geotags.push(tag)
  },
}

const getters = {
  tagByID: (state) => (tagID) => {
    return state.geotags.find(gt => gt.id === tagID)
  },
  stateTags (state) {
    return state.geotags.filter(gt => gt.segmentType === 'state')
  },
  regionTags (state) {
    return state.geotags.filter(gt => gt.segmentType === 'region')
  },
  defaultTags (state) {
    return state.geotags.filter(gt => gt.segmentType === 'default')
  }
}

const actions = {
  getAll (ctx) {
    return new Promise((resolve, reject) => {
      geoTagApi.getAll(tags => {
        ctx.commit('setTags', tags)
        resolve(tags)
      },
      error => {
        reject(error)
      })
    })
  },

  create (ctx, params) {
    return new Promise((resolve, reject) => {
      geoTagApi.create(params, tag => {
        ctx.commit('addTag', tag)
        resolve(tag)
      },
      err => {
        reject(err)
      })
    })
  },

  removeWorksiteTag (ctx, args) {
    const { worksiteID, tagID } = args
    console.log('wid ', worksiteID, ' tagdi ', tagID)
    return new Promise((resolve, reject) => {
      geoTagApi.removeWorksiteFrom(args, response => {
        ctx.dispatch('getAll')
        resolve(response)
      },
      err => {
        reject(err)
      })
    })
  },

  addWorksitesTag (ctx, args) {
    const { worksiteIDs, tagID } = args
    console.log('wids ', worksiteIDs, ' tagdi ', tagID)
    return new Promise((resolve, reject) => {
      geoTagApi.addWorksitesTo(args, response => {
        ctx.dispatch('getAll')
        resolve(response)
      },
      err => {
        reject(err)
      })
    })
  },

  updateMembers (ctx, args) {
    return new Promise((resolve, reject) => {
      geoTagApi.updateMembers(args, response => {
        ctx.dispatch('getAll')
        resolve(response)
      },
      err => {
        reject(err)
      })
    })
  },

  // delete ({ commit }, id) {
  //   return new Promise((resolve, reject) => {
  //     holidayApi.delete(id, holiday => {
  //       resolve(holiday)
  //     },
  //     err => {
  //       reject(err)
  //     })
  //   })
  // }
}

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations
}
